module.exports = __webpack_public_path__ + "img/nc.17a58f9c.svg";